<sm-model-view-network
  [model]="(selectedModel$ | async)"
  [isSharedAndNotOwner]="isSharedAndNotOwner$ | async"
  [saving]="(saving$ | async)"
  (saveFormData)="saveFormData($event)"
  (cancelClicked)="cancelClicked()"
  (activateEditClicked)="activateEditClicked()"
></sm-model-view-network>
